import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const currencyBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'directories',
    url: '/directories/stock'
  },
  {
    label: 'currency',
    active: true
  }
];

export type CurrencyType = {
  name: string;
  code: string;
  number_code: string;
  banknot: string;
  country: string;
  main_currency: string;
  status: string;
  guid: string;
  currency_id?: string;
};
